export type ScriptValidationContext = Record<string, object>

export const getScriptValidationContext = (
  overrides: Partial<ScriptValidationContext> = {}
): ScriptValidationContext => ({
  // Базовый набор доступных аргументов для JS-скриптов
  srcObj: {},
  outerSrcObj: {},
  enrichedObject: {},
  formValues: {},
  rowData: {},
  currentRowValues: {},
  formVariables: [],
  outerVariables: {},
  variableValue: {},
  column: {},
  commandResponse: {},
  ...overrides,
})
